'use server'

import { cookies } from 'next/headers'
import { redirect } from 'next/navigation'

const API_URL = process.env.API_URL || 'http://localhost:3000'

export async function login(_prev: any, formData: FormData) {
  const email = formData.get('email') as string
  const password = formData.get('password') as string

  const res = await fetch(`${API_URL}/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  })

  const data = await res.json()

  if (!res.ok) {
    if (data.code === 'EMAIL_NOT_VERIFIED') {
      return { error: 'メールアドレスが未確認です。届いた確認メールをご確認ください。', code: 'EMAIL_NOT_VERIFIED', email }
    }
    return { error: data.error }
  }

  const cookieStore = await cookies()
  cookieStore.set('token', data.token, {
    httpOnly: true,
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax',
    maxAge: 60 * 60 * 24 * 30,
    path: '/',
  })

  redirect('/dashboard')
}

export async function register(_prev: any, formData: FormData) {
  const email = formData.get('email') as string
  const password = formData.get('password') as string
  const name = formData.get('name') as string

  const res = await fetch(`${API_URL}/api/auth/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password, name }),
  })

  const data = await res.json()

  if (!res.ok) return { error: data.error }

  return { success: true, email }
}

export async function verifyEmail(_prev: any, formData: FormData) {
  const token = formData.get('token') as string

  const res = await fetch(`${API_URL}/api/auth/verify-email`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token }),
  })

  const data = await res.json()
  if (!res.ok) return { error: data.error }

  const cookieStore = await cookies()
  cookieStore.set('token', data.token, {
    httpOnly: true,
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax',
    maxAge: 60 * 60 * 24 * 30,
    path: '/',
  })

  redirect('/dashboard')
}

export async function resendVerify(_prev: any, formData: FormData) {
  const email = formData.get('email') as string

  const res = await fetch(`${API_URL}/api/auth/resend-verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  })

  const data = await res.json()
  if (!res.ok) return { error: data.error }
  return { success: true }
}

export async function forgotPassword(_prev: any, formData: FormData) {
  const email = formData.get('email') as string

  const res = await fetch(`${API_URL}/api/auth/forgot-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  })

  const data = await res.json()
  if (!res.ok) return { error: data.error }
  return { success: true }
}

export async function resetPassword(_prev: any, formData: FormData) {
  const token = formData.get('token') as string
  const password = formData.get('password') as string

  const res = await fetch(`${API_URL}/api/auth/reset-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, password }),
  })

  const data = await res.json()
  if (!res.ok) return { error: data.error }
  return { success: true }
}

export async function logout() {
  const cookieStore = await cookies()
  cookieStore.delete('token')
  redirect('/login')
}
